import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BerichtService } from '../service';

@Component({
  selector: 'fa-kt-bericht-detail',
  templateUrl: './bericht-detail.component.html',
  styleUrls: ['./bericht-detail.component.css'],
})
export class BerichtDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public bericht: BerichtService) {}
}
